import type { UserSortOption } from '@features/users/api/get-users/getUsers.types';
import type { SortDirection } from '@shared/types/sort.types';

export function buildSortParam(
  sortBy: string,
  sortDirection: SortDirection
): UserSortOption {
  const prefix = sortDirection === 'desc' ? '-' : '+';
  return `${prefix}${sortBy}` as UserSortOption;
}
